import React from 'react';

function Footer() {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2025 Jason Ranney - Southeast Hard Surface Territory Manager | Serving Flooring Retailers in South Florida & Southeast Florida</p>
      </div>
    </footer>
  );
}

export default Footer; 